const initialPosts = [
    {
        id: 1,
        tag: "Article",
        title: "Boost your conversion rate",
        thumbnail: "https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80",
        author: "Learn with sumit",
        authorAvatar: "https://avatars.githubusercontent.com/u/73503432?v=4",
        postDate: "11 Jul, 2022",
        readingDuration: 6
    },
    {
        id: 2,
        tag: "Camera",
        title: "Best Camera",
        thumbnail: "https://images.unsplash.com/photo-1659536540455-161b929e650c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
        author: "Arzu",
        authorAvatar: "https://avatars.githubusercontent.com/u/10987108?v=4",
        postDate: "11 Jul, 2022",
        readingDuration: 6
    },
    {
        id: 3,
        tag: "Food",
        title: "Dinner Buffet",
        thumbnail: "https://images.unsplash.com/photo-1661366394743-fe30fe478ef7?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
        author: "Pallab",
        authorAvatar: "https://avatars.githubusercontent.com/u/59387756?v=4",
        postDate: "11 Jul, 2022",
        readingDuration: 6
    },
    {
        id: 4,
        tag: "Music",
        title: "Music Concert",
        thumbnail: "https://images.unsplash.com/photo-1661409109307-2acdba6be15a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
        author: "Riaz",
        authorAvatar: "https://avatars.githubusercontent.com/u/33659227?v=4",
        postDate: "11 Jul, 2022",
        readingDuration: 6
    },
    {
        id: 5,
        tag: "Accessories",
        title: "Portable SSD",
        thumbnail: "https://images.unsplash.com/photo-1659535953562-f6e9d68deb92?ixlib=rb-1.2.1&ixid=MnwxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
        author: "Abu Sadat",
        authorAvatar: "https://avatars.githubusercontent.com/u/10849523?v=4",
        postDate: "11 Jul, 2022",
        readingDuration: 6
    },
    {
        id: 6,
        tag: 'Article',
        title: 'Traveling',
        thumbnail: 'https://images.unsplash.com/photo-1660866837205-348b627e3909?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80',
        author: 'Arzu',
        authorAvatar: 'https://avatars.githubusercontent.com/u/10987108?v=4',
        postDate: '11 Jul, 2022',
        readingDuration: 3
    },
    {
        id: 7,
        tag: 'Camera',
        title: 'Quick Camera',
        thumbnail: 'https://images.unsplash.com/photo-1659535824233-966cc8de61a5?ixlib=rb-1.2.1&ixid=MnwxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1172&q=80',
        author: 'Pallab',
        authorAvatar: 'https://avatars.githubusercontent.com/u/59387756?v=4',
        postDate: '11 Jul, 2022',
        readingDuration: 10
    },
    {
        id: 8,
        tag: 'Food',
        title: 'Swimming',
        thumbnail: 'https://images.unsplash.com/photo-1661381166315-4f82d845394e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80',
        author: 'Abu Sadat',
        authorAvatar: 'https://avatars.githubusercontent.com/u/10849523?v=4',
        postDate: '11 Jul, 2022',
        readingDuration: 10
    }, {
        id: 9,
        tag: 'Camera',
        title: 'Photo Shoot',
        thumbnail: 'https://images.unsplash.com/photo-1660866837676-7211e74f1d78?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80',
        author: 'Riaz',
        authorAvatar: 'https://avatars.githubusercontent.com/u/33659227?v=4',
        postDate: '11 Jul, 2022',
        readingDuration: 8
    }, {
        id: 10,
        tag: 'Food',
        title: 'Breakfast',
        thumbnail: 'https://images.unsplash.com/photo-1661335996027-0a65af891c27?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80',
        author: 'Riaz',
        authorAvatar: 'https://avatars.githubusercontent.com/u/33659227?v=4',
        postDate: '11 Jul, 2022',
        readingDuration: 6
    }, {
        id: 11,
        tag: 'Accessories',
        title: 'Car Washing',
        thumbnail: 'https://images.unsplash.com/photo-1661324593223-e906644f88d6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1171&q=80',
        author: 'Riaz',
        authorAvatar: 'https://avatars.githubusercontent.com/u/33659227?v=4',
        postDate: '11 Jul, 2022',
        readingDuration: 10
    },
    {
        id: 12,
        tag: 'Accessories',
        title: 'Mouse and Headphone',
        thumbnail: 'https://images.unsplash.com/photo-1661347561443-bae23f383773?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80',
        author: 'Learn with sumit',
        authorAvatar: 'https://avatars.githubusercontent.com/u/73503432?v=4',
        postDate: '11 Jul, 2022',
        readingDuration: 2
    },
    {
        id: 13,
        tag: 'Accessories',
        title: 'Fast Speed SSD',
        thumbnail: 'https://images.unsplash.com/photo-1659535969472-3f4e2ad3a0be?ixlib=rb-1.2.1&ixid=MnwxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80',
        author: 'Abu Sadat',
        authorAvatar: 'https://avatars.githubusercontent.com/u/10849523?v=4',
        postDate: '11 Jul, 2022',
        readingDuration: 4
    },
    {
        id: 14,
        tag: 'Article',
        title: 'Dance on Road',
        thumbnail: 'https://images.unsplash.com/photo-1661264254942-6c4beebe6e14?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80',
        author: 'Abu Sadat',
        authorAvatar: 'https://avatars.githubusercontent.com/u/10849523?v=4',
        postDate: '11 Jul, 2022',
        readingDuration: 3
    },
    {
        id: 15,
        tag: 'Article',
        title: 'Fishing on River',
        thumbnail: 'https://images.unsplash.com/photo-1661076530383-72280f3c69de?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80',
        author: 'Arzu',
        authorAvatar: 'https://avatars.githubusercontent.com/u/10987108?v=4',
        postDate: '11 Jul, 2022',
        readingDuration: 1
    },
    {
        id: 16,
        tag: 'Accessories',
        title: '256GB Memory Card',
        thumbnail: 'https://images.unsplash.com/photo-1659536019078-361c92fbfdf6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80',
        author: 'Arzu',
        authorAvatar: 'https://avatars.githubusercontent.com/u/10987108?v=4',
        postDate: '11 Jul, 2022',
        readingDuration: 8
    }, {
        id: 17,
        tag: 'Music',
        title: 'Best Music System on Car',
        thumbnail: 'https://images.unsplash.com/photo-1661336878257-1c51b5af959a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80',
        author: 'Learn with sumit',
        authorAvatar: 'https://avatars.githubusercontent.com/u/73503432?v=4',
        postDate: '15 Jul, 2022',
        readingDuration: 7
    },
    {
        id: 18,
        tag: 'Food',
        title: 'Healthy Food for Life',
        thumbnail: 'https://images.unsplash.com/photo-1657299171251-2a61ea716fbf?ixlib=rb-1.2.1&ixid=MnwxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80',
        author: 'Learn with sumit',
        authorAvatar: 'https://avatars.githubusercontent.com/u/73503432?v=4',
        postDate: '15 Jul, 2022',
        readingDuration: 6
    },
    {
        id: 19,
        tag: 'Camera',
        title: 'Ultra low light camera',
        thumbnail: 'https://images.unsplash.com/photo-1661297391264-9ad5761719e6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=688&q=80',
        author: 'Learn with sumit',
        authorAvatar: 'https://avatars.githubusercontent.com/u/73503432?v=4',
        postDate: '15 Jul, 2022',
        readingDuration: 7
    }, {
        id: 20,
        tag: 'Accessories',
        title: 'Gen4 M.2 SSD',
        thumbnail: 'https://images.unsplash.com/photo-1657214059139-dc58d16118ed?ixlib=rb-1.2.1&ixid=MnwxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=736&q=80',
        author: 'Pallab',
        authorAvatar: 'https://avatars.githubusercontent.com/u/59387756?v=4',
        postDate: '15 Jul, 2022',
        readingDuration: 8
    }


];
export default initialPosts;